module.exports = __webpack_public_path__ + "img/Finnya-logo.b1bbd960.svg";